export enum PointCloudChannel {
    INTENSITY = "INTENSITY",
    RGB = "RGB",
}
